<template>
  <div class="printPage" id="printPage">
    <div class="print-title">
      <img src="@/assets/img/common/logo.png"/>
    </div>
    <div class="print-header">
      评价通知书正文
    </div>
    <div class="print-body">
      <h3>易派客产品质量评价通知单(NO:{{baseInfo.noticeNo}})</h3>
      <p class="print-name">中国质量认证中心：</p>
      <p class="print-content">
        贵公司申请的受理单号{{baseInfo.evaluationCode}}质量评价已受理，中国石油化工股份有限公司大连石油化工研究院将在近期赴贵单位开展评价工作，请做好相关准备工作 。
      </p>

      <div class="print-sign">
        <div>易派客电子商务有限公司</div>
        <div>{{baseInfo.noticeTime}}</div>
      </div>
    </div>
    <div class="print-btn no-print" v-if="isShowExport">
      <eui-btn type="secondary" @click="handleClose">返 回</eui-btn>
      <div>
        <eui-btn type="secondary" @click="handlePrint">打印</eui-btn>
        <eui-btn type="primary" v-debounce="handleExportPdf">导出PDF</eui-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/modules/projectA/api/ESorganization/index';

  export default {
    name: 'evaluationNotice',
    data() {
      return {
        isShowExport: true,
        logo: require('@/assets/img/common/epec.png'),
        baseInfo:{},
      };
    },
    mounted() {
      this.applyNoticeQueryApplyNotice();
    },
    methods: {
      async applyNoticeQueryApplyNotice(){
        const res = await api.applyNoticeQueryApplyNotice({applyId:this.$route.query.applyId});
        if(res.success){
            this.baseInfo = res.data;
        }
      },
      handlePrint() {
        window.print();
      },
      handleClose() {
         this.$router.back();
      },
      handleExportPdf() {
        this.isShowExport = false;
        this.$nextTick(() => {
          this.getPdf('printPage', `易派客产品质量评价通知单(NO:${this.baseInfo.noticeNo})`, () => {
            this.isShowExport = true;
          });
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/css/theme.scss';

  @media print {
    /* 打印时不需要显示的元素 */
    .no-print {
      display: none !important;
    }
    .printPage {
      margin: 20px 20px 0 !important;
      transform: scale(0.63) !important;
      transform-origin: left top !important;
      -webkit-print-color-adjust: exact;
      -moz-print-color-adjust: exact;
      -ms-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .calendar {
      /* 隐藏日历页面中不需要打印的元素 */
      display: none;
    }
  }

  .printPage {
    width: 1200px;
    max-height: 800px;
    margin: 0 auto;
    padding-bottom: 30px;
    background: url("~@/assets/img/common/bk-epk.png") repeat;
    font-family: Source Han Sans CN;
  }

  .print-title {
    padding: 20px;

    img {
      width: 218px;
      height: 54px;
      vertical-align: top;
    }
  }

  .print-header {
    width: 1160px;
    margin: 0 auto;
    padding-left: 20px;
    height: 40px;
    line-height: 40px;
    color: #ffffff;
    background: $main-col;
  }

  .print-body {
    width: 1160px;
    min-height: 418px;
    margin: 0 auto;
    padding: 30px 20px 20px;
    border: 1px solid #D9D9D9;
    border-top: 0;

    > h3 {
      margin-bottom: 30px;
      font-size: 20px;
      line-height: 1;
      text-align: center;
      font-weight: normal;
    }

    > .print-name {
      margin-bottom: 20px;
      font-size: 16px;
      line-height: 1;
    }

    .print-content {
      text-indent: 2em;
      font-size: 16px;
      line-height: 21px;
      text-align: justify;
    }
  }

  .print-sign {
    margin-top: 176px;
    text-align: right;
  }

  .print-btn {
    padding: 20px 20px 0;
    display: flex;
    justify-content: space-between;
  }
</style>
<style>
  @media print {
    html, body, #app, .wrapper {
      height: auto !important;
    }
  }
</style>
